<button
  [class]="'pr-switch-button ' + (value ? 'toggled' : '')"
  (click)="onClick()"
>
  <div class="white-circle"></div>
</button>
